import { render } from "./MfgWuJianInfoEdit.vue?vue&type=template&id=1c9981c3"
import script from "./MfgWuJianInfoEdit.vue?vue&type=script&lang=js"
export * from "./MfgWuJianInfoEdit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__